import { formatConfidenceFilter } from "react/utils/utils";

class MassiveSmartGeocodeRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'MassiveSmartGeocode';
        const model = App.Models.MassiveSmartGeocode;
        const collectionClass = App.Collections.MassiveSmartGeocodes;

        super(entityName, model, collectionClass);

        const options = Monet.Grid.Utils.paginationOptions;
        if (!App.Forms.MassiveSmartGeocode) {
            App.Forms.MassiveSmartGeocode = {
                layout: {},
                dataMapper: null,
                pagination: {
                    first: options.FIRST,
                    max: options.MAX_RESULT,
                    blocked: false,
                    canIncrement: true
                },
                columnToOrders: []
            };
        }
    }

    getProjection = () => {
        return JSON.stringify({
            filters: [
                "id",
                "location.id",
                "location.key",
                "location.description",
                "location.organization.description",
                "location.latitude",
                "location.longitude",
                "location.geocodingQuality",
                "location.geocodingDate",
                "location.geocodingLastCheck",
                "location.geocodingUser.name",
                "location.addressLine1",
                "location.addressLine2",
                "location.city",
                "location.country",
                "location.zipCode",
                "confidence",
                "proposedLat",
                "proposedLong",
                "locationsDistance",
                "totalStops",
                "validStops"
            ],
            firstResult: App.Forms.MassiveSmartGeocode.pagination.first,
            maxResults: App.Forms.MassiveSmartGeocode.pagination.max
        });
    }

    adjustHeaderSize = () => {
        const header = document.querySelector('#SmartGeocode .gridActions .actions');
        
        this.el = App.Forms[this.entityName].filterBuilder.el;
        const selector = document.querySelector('#SmartGeocode .display.ui-widget');

        let height = this.el.scrollHeight;
        
        if (header) {
            
            if (height > 160) {
                header.style.height = '160px';
                this.el.style.overflowY = 'scroll';
            } else {
                if(header.style) {
                    if (height > 0) {
                        header.style.height = height + 'px';
                    }
                    this.el.style.overflowY = 'auto';
                }
            }
        }
        
        const grid = selector;
        
        if (grid && header) {
            this.offsetTop =  this.offsetTop ||  header.offsetTop;
            grid.style.top = (this.offsetTop + header.offsetHeight) + 'px';
        }

        if (this.customNameSpace && App.Forms[this.customNameSpace].table) {
            App.Forms[this.customNameSpace].table.resizeCanvas();
        } else {

            if (App.Forms[this.entityName] && App.Forms[this.entityName].table) {
                App.Forms[this.entityName].table.resizeCanvas();
            }

        }
    }

    createTemplate = (callback) => {
      const smartGeocode = document.querySelector("#SmartGeocode");
      if(smartGeocode.querySelector("#smartGeocodeListConteiner") === null) {
        smartGeocode.appendChild(Greenmile.Templates.getSmartGeocodeListConteiner());
      }
      callback();
    }

    goToScreen = function (screen, options) {
        try {
            const tabContainer = document.getElementById('SmartGeocode');
            while (tabContainer.firstChild) {
                tabContainer.removeChild(tabContainer.firstChild);
            }

            switch(screen) {
                case 'form':
                    App.Views.MassiveSmartGeocode.showForm(options);
                    break;
                case 'grid':
                    this.generateListSmartGeocodes();
                    break;
                case 'map':
                    options && options.locationId && this.showDetailSmartGeocode(options.locationId);
                    break;
                default:
                    this.checkProgress();
                    break;
            }
        } catch (e) {
            const error = new Monet.Exception.ReturnError(this, 'Error rendering screen "' + (screen || '') + '"', e);
            error.console();
        }
    }

    handleError = (errorCallback, { response }) => {
        const { errorMessages } = response ? JSON.parse(response) : {
            errorMessages: [Monet.Form.Messages.mountErrorMessageObject('SmartGeocode.form.requestError')]
        };
        errorCallback([errorMessages[0]]);
    }

    getProcessState =(successCallback, errorCallback) => {
        const ajax = new Monet.Ajax();
        ajax.url = '/MassiveSmartGeocode/ProcessStatus/';
        ajax.method = 'get';
        ajax.success = (data) => {
            if (data) {
                if (successCallback && data) {
                    Greenmile.MassiveSmartGeocode.currentProcessId = data.processId;
                    successCallback(data);
                }
            }     
        };
        ajax.error = (error) => {
            if (errorCallback) {
                this.handleError(errorCallback, error);
            }
        };
        ajax.send();
    }

    checkProgress = () => {
        const successCallback = (data) => {
            if (data.status === 'PROCESSING' && data.processStatus < 1) {
                App.Views.MassiveSmartGeocode.showProgressBar(data.processStatus, 'processingRouter');
            } else if (data.status === 'PROCESSED' && data.processStatus === 1) {
                const alert = new Greenmile.MassiveSmartGeocode.PopupAlert('#SmartGeocode');
                alert.showPopup(data.startDate);
            } else {
                this.goToScreen('form');
            }
        };

        const errorCallback = (errorMessages) => {
            this.goToScreen('form', { errorMessages });
        };

        this.getProcessState(successCallback, errorCallback);
    }

    updateProgress = (updateCallback, finishedCallback) => {
        const successCallback = (data) => {
            const progressBar = new Greenmile.MassiveSmartGeocode.ProgressBar('#SmartGeocode', 'processingRouter');

            if ((data.status === 'PROCESSING' || data.status === 'PROCESSED') && data.processStatus <= 1) {
                progressBar.update(data.processStatus);
                if (finishedCallback && data.processStatus === 1) {
                    setTimeout(finishedCallback, 1000);
                } else if (updateCallback) {
                    updateCallback();
                }
            }
            
        };

        const errorCallback = (errorMessages) => {
            this.goToScreen('form', { errorMessages });
        };

        this.getProcessState(successCallback, errorCallback);
    }

    startProcess = (data, successCallback, errorCallback) => {
        const ajax = new Monet.Ajax();
        ajax.url = '/MassiveSmartGeocode/Process';
        ajax.method = 'post';
        ajax.data = data;
        ajax.success = (data) => {
            if (data && successCallback) {
                successCallback(data);
            }
        };
        ajax.error = (error) => {
            if (errorCallback) {
                this.handleError(errorCallback, error);
            }
        };
        ajax.send();
    }

    generateListSmartGeocodes = () => {
        const callback = function () {
            const view = App.Views.MassiveSmartGeocode;
            const gridActions = document.querySelector('#SmartGeocode .form-vertical.gridActions');

            const helpTo = 'SmartGeocode';
            const title = Monet.I18n.getResourcesByKey('SmartGeocode.title');
            const helper = new Monet.UI.Help(helpTo, title);

            gridActions.insertBefore(view.buildGridHeader(), gridActions.firstChild);
            gridActions.querySelector('.grid_header__rigth').appendChild(helper.render());
            
            view.showGrid();
        };

        this.createTemplate(callback);
    }

    getFilter = () => {

        let filterBuilder = App.Forms.MassiveSmartGeocode.filterBuilder;

        if (!filterBuilder) {
            new Monet.Exception.ReturnError(this, "Error trying to get filterBuilder.") 
                .console();
            return;
        }

        const filter = filterBuilder.getCriteriaChain();
        filter.sort = [];

        const columnsToOrder = App.Forms.MassiveSmartGeocode.columnToOrders;
        if (columnsToOrder) {
            columnsToOrder.forEach(column => {
                filter.sort.push({
                    attr: column.field,
                    type: column.order
                });
            });
        }

        return filter;
    }

    getSmartGeocodes = (filter, callback, appendCollection) => {
        try {
            const entity = 'MassiveSmartGeocode';
            const columns = App.Forms.MassiveSmartGeocode.table.getColumns();
            const filterBuilder = App.Forms.MassiveSmartGeocode.filterBuilder;
            filterBuilder.loading.show();

            this.collection.fetchWithCriteria({
                criteria: this.getProjection(),
                filter: JSON.stringify(filter),
                add: appendCollection,
                success: function (data) {
                    filterBuilder.loading.hide();
                    if (callback) {
                        Greenmile.MassiveSmartGeocode.data = data;
                        callback(entity, columns, data, true);
                    }
                },
                error: function () {
                    filterBuilder.loading.hide();
                }
            });

        } catch (e) {
            const error = new Monet.Exception.ReturnError(this, 'Error getting Smart Geocode data');
            error.console();
        }
    }

    updateGrid = (filter, callback, appendCollection) => {
      const formattedFilters = formatConfidenceFilter(filter);
    
      this.getSmartGeocodes(formattedFilters, callback, appendCollection);
    }

    getColumnsToGridLayout = async () => {
        const request = new Monet.Ajax({
            url: 'form/MassiveSmartGeocode/index',
            success: (data) => {
                App.Forms.MassiveSmartGeocode.layout['index'] = data;
            },
            error: (xhr) => {
                Monet.Configurations.errorNotification(null, xhr);
            }
        });

        await request.send();
    }

    removeElementsMap = () => {
        const smartGeocodeSelector = '#SmartGeocode';
        const mapCon = document.querySelector(smartGeocodeSelector + " #mapCon");
        const streetView = document.querySelector(smartGeocodeSelector + " .streetView");
        const streetViewCloseBtn = document.querySelector(smartGeocodeSelector + " .streetViewCloseBtn");

        if (mapCon) {
            const parentNode = mapCon.parentNode;
            if (parentNode) {
                parentNode.removeChild(mapCon);
            }
        }

        if (streetView) {
            const parentNode = streetView.parentNode;
            if (parentNode) {
                parentNode.removeChild(streetView);
            }
        }

        if (streetViewCloseBtn) {
            const parentNode = streetViewCloseBtn.parentNode;
            if (streetViewCloseBtn) {
                parentNode.removeChild(streetViewCloseBtn);
            }
        }
    }

    showDetailSmartGeocode = (locationId) => {
        const view = App.Views.MassiveSmartGeocode;
        this.removeElementsMap();

        const callback = function () {
            const smartGeocodeListContainer = document.querySelector("#smartGeocodeListConteiner");
            const smardGeocodeDetailHtml = document.querySelector("#smartGeocodeDetail");

            smartGeocodeListContainer.style.display = "none";
            smardGeocodeDetailHtml.appendChild(Greenmile.Templates.getSmartGeocodeMapButtonsContainer());
            smardGeocodeDetailHtml.style.display = "block";

            const itemData = Greenmile.MassiveSmartGeocode.data.models.filter(obj => obj.get("location").id === locationId);

            if (itemData && itemData[0]) {
                view.showMapAndDetailSmartGeocode(itemData[0].attributes);
            } else {
                new Greenmile.Components.AlertModal('SmartGeocode.alert.nothingData')
                    .show();
            }
        };

        this.createTemplate(callback);
    }

    acceptAll = (successCallback, errorCallback) => {
        const models = Greenmile.MassiveSmartGeocode.data;
        const processId = models.at(0).attributes.processId;

        const ajax = new Monet.Ajax();
        ajax.method = 'get';
        ajax.url = 'MassiveSmartGeocode/SaveAll/' + processId,
        ajax.success = function () {
            if (successCallback) {
                successCallback();
            }
        };
        ajax.error = function () {
            if (errorCallback) {
                errorCallback();
            }
        };
        ajax.send();
    }

    acceptSelected = (rows, successCallback, errorCallback) => {

        const models = Greenmile.MassiveSmartGeocode.data;
        const processId = models.at(0).attributes.processId;
        let data = [];

        rows.forEach(row => {
            const item = models.at(row).attributes;
            data.push({ 
                smartGeocodeId: item.id,
                locationId: item.location.id,
                position: {
                    latitude: item.proposedLat,
                    longitude: item.proposedLong
                } 
            });
        });

        const ajax = new Monet.Ajax();
        ajax.method = 'put';
        ajax.data = data;
        ajax.url = 'MassiveSmartGeocode/SaveBatch/' + processId,
        ajax.success = function () {
            if (successCallback) {
                successCallback();
            }
        };
        ajax.error = function () {
            if (errorCallback) {
                errorCallback();
            }
        };
        ajax.send();
    }

    savePosition = (smartGeocodeId, processId, locationId, callback) => {
        const massiveSmartG = new Greenmile.MassiveSmartGeocode.Map()
        massiveSmartG.setLoadingInBtn();

        const data = { smartGeocodeId, locationId, position: Greenmile.MassiveSmartGeocode.correctPosition };

        const ajax = new Monet.Ajax();
        ajax.method = 'put';
        ajax.data = data;
        ajax.url = 'MassiveSmartGeocode/Save/' + processId,
        ajax.success = function () {
            if (callback) {
                callback();
            }
        };
        ajax.send();

    }

    discardSuggestion = (smartGeocodeId, callback) => {
        const massiveSmartG = new Greenmile.MassiveSmartGeocode.Map()
        massiveSmartG.setLoadingInBtn();

        const ajax = new Monet.Ajax();
        ajax.method = 'get';
        ajax.url = 'MassiveSmartGeocode/Discard/' + smartGeocodeId,
        ajax.success = function () {
            if (callback) {
                callback();
            }
        };
        ajax.send();
    }

}

App.Routers.MassiveSmartGeocode = MassiveSmartGeocodeRouter;
